import React from 'react'
import Create from '../crud/create'
import menuItems from '../promo-code-discounts/menuItems'

const fields = [
  {
    name: 'Discount',
    prop: 'discount_id',
    type: 'autocomplete',
    references: 'admin/discounts',
    referenceProp: 'code'
  }
]

const CreatePromoCodeDiscountForPromoCode = (props) => {
  const { promoCodeId } = props.params

  return (
    <Create
      title='Link Discount to Promo Code'
      fields={fields}
      apiPath='admin/promo_code_discounts'
      resource={{ promo_code_id: parseInt(promoCodeId, 10) }}
      successRedirectPath={`/ecommerce/promo-codes/${promoCodeId}/discounts`}
      buildMenuItems={menuItems}
    />
  )
}

export default CreatePromoCodeDiscountForPromoCode
